// removed by extract-text-webpack-plugin
module.exports = {"app":"L_Sn1hz6-Iv1pWxIGUGEH"};